export const FORM_INPUTS = {
    firstName: {
        element: document.getElementById('firstName'),
        pattern: '^.{2,}$',
        maxLength: 70,
        type: 'text',
    },
    lastName: {
        element: document.getElementById('lastName'),
        pattern: '^.{3,}$',
        maxLength: 70,
        type: 'text',
    },
    phoneNumber: {
        element: document.getElementById('phoneNumber'),
        type: 'tel',
        maxLength: '20',
    },
    address: {
        element: document.getElementById('address'),
        pattern: '^.{3,}$',
        maxLength: 20,
        type: 'text',
    },
    city: {
        element: document.getElementById('city'),
        pattern: '^.{2,}$',
        maxLength: 40,
        type: 'text',
    },
    zipCode: {
        element: document.getElementById('zipCode'),
        pattern: '^.{3,}$',
        maxLength: 20,
        type: 'text',
    },
    state: {
        element: document.getElementById('state'),
        pattern: '^.{2,}$',
        maxLength: 50,
        type: 'text',
    },
    email: {
        element: document.getElementById('email'),
        type: 'email',
        required: true,
        pattern:
            "[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?",
        maxLength: 100,
    },
    monthExpiry: {
        element: document.getElementById('monthExpiry'),
        required: true,
        autocomplete: 'cc-exp-month',
    },
    yearExpiry: {
        element: document.getElementById('yearExpiry'),
        required: true,
        autocomplete: 'cc-exp-year',
    },
    cardNumber: {
        element: document.getElementById('cardNumber'),
        pattern: '[0-9]{16}',
        maxLength: 16,
        required: true,
        type: 'tel',
        autocomplete: 'cc-number',
    },
    cvv: {
        element: document.getElementById('cvv'),
        pattern: '^[0-9]{3}$',
        maxLength: 3,
        required: true,
        type: 'tel',
        autocomplete: 'cc-csc',
    },
    cardHolder: {
        element: document.getElementById('cardHolder'),
        pattern: '^.{2,}$',
        required: true,
        maxLength: 60,
        type: 'text',
        autocomplete: 'cc-name',
    },
    oneExpiryInput: {
        element: document.getElementById('expiry'),
        required: true,
        autocomplete: 'cc-exp',
        pattern: '(0[1-9]|1[0-2])\\/\\d{2}'
    }
}

export const initInputOptions = () => {
    for (let data in FORM_INPUTS) {
        let element = FORM_INPUTS[data].element;

        if (element) {
            for (let attribute in FORM_INPUTS[data]) {
                let value = FORM_INPUTS[data][attribute];

                if (value && attribute !== 'element' && !element.getAttribute(attribute)) {
                    element.setAttribute(attribute, value);
                }
            }
        }
    }
};